import { render, staticRenderFns } from "./EditLeak.vue?vue&type=template&id=64f376f0&"
import script from "./EditLeak.vue?vue&type=script&lang=js&"
export * from "./EditLeak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports